import { Component, Input, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  RichTextAreaComponent,
  RichTextCompTextFormat,
} from '@app/storybook/components/rich-textarea/rich-textarea.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.scss'],
  standalone: false,
})
export class RichTextEditor implements AfterViewInit, OnDestroy {
  @Input() label: string = '';
  @Input() placeholder: string = 'Text field';
  @Input() initialContent: string = '';
  @Input() control!: FormControl;
  @Input() config: any = {};
  @Input() invalidMsg: string = null;
  @Input() disabledFormats: RichTextCompTextFormat[] = ['underline'];
  @Input() enableLinkInsert = false;

  @ViewChild('richText') richTextRef!: RichTextAreaComponent;

  private subscription: Subscription;

  ngAfterViewInit(): void {
    if (this.control.value) {
      this.richTextRef.setContent(this.control.value);
    }

    this.subscription = this.control.valueChanges.subscribe((value) => {
      if (this.richTextRef.getContent() !== value) {
        this.richTextRef.setContent(value || '');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onRichTextChange(content: string): void {
    this.control.setValue(content);
    this.control.markAsTouched();
    this.control.markAsDirty();
  }
}
